<template>

  <div>
    <el-row>
      <h2>Project/Planner Dept</h2>
      <el-col :span="24">

        <el-alert :type="step2p1.approved ? 'success' : 'warning'" :title="(step2p1.approved ? step2p1.approvedStatus : 'Pending Approval')" show-icon :closable="false">
          <div  v-if="step2p1 && step2p1.approvedStatus && !isPending">
            <p v-if="step2p1.approved_at">on <b>{{formatDate(step2p1.approved_at)}}</b> by <b>{{step2p1.approved_by}}</b></p>
            <p v-if="step2p1.state.reSurvey || step2p1.state.reviseTP">Actions Required</p>
            <p v-if="step2p1.state.reSurvey"><i class="fa fa-check"></i> Re-survey Required</p>
            <p v-if="step2p1.state.reviseTP"><i class="fa fa-check"></i> Revise Technical Propsal</p>
          </div>

        </el-alert>

        <br />

        <div v-if="step2p1.remarks">
          <div class="html-remarks">
            <strong v-text="(step2p1.approvedStatus ? step2p1.approvedStatus + ' ' : '') + 'Remarks'"></strong>
            <html-input v-if="step2p1.remarks" v-model="step2p1.remarks"no-form disabled />
            <p v-else class="text-muted">No remarks</p>
          </div>
        </div>

      </el-col>
    </el-row>

    <div>
      <h2>Finance Dept</h2>
      <el-alert :type="step.legalApproved ? 'success' : 'warning'"
        :title=" (step.docType ? step.docType : 'legal documents') + ' ' + (step.legalApproved ? 'Approved' : 'Pending Approval')"
        show-icon :closable="false">
        <span v-if="step.legalApproved && step3p1.approved"><b>{{formatDate(step3p1.approved_at)}}</b> by <b>{{step3p1.approved_by}}</b></span>
      </el-alert>
    </div>

    <br />
  </div>

</template>

<script>

import RequestMixins from '@/mixins/RequestMixins'

export default {

  mixins: [RequestMixins],

  props: {

    rowData: {
      type: Object,
      required: true
    },

    steps: {
      type: Array,
      required: true
    },

    legalStep: {
      type: Number,
      required: true
    }

  },

  data () {
    return {
      step: this.rowData ? this.rowData.state['step' + this.legalStep] : {},
      step2p1: this.findWorkflowStep(2, 1, this.steps),
      step3p1: this.findWorkflowStep(3, 1, this.steps)
    }
  }

}
</script>
